<template>
  <div>
    <div class="catergories__banner" v-if="isSlimBanner">
      <img
        v-show="this.slimBanner"
        :src="this.slimBanner"
        alt="slim_banner_image"
      />
    </div>
    <div class="categories__main">
      <div class="categories__submenus">
        <span> {{ this.slug }} ></span>

        <span
          :class="
            submenu.id == SubmenuId ? 'span_Activesubmenu' : 'span__submenu'
          "
          v-for="submenu in filteredSubMenu"
          :key="submenu.id"
          @click="getSubmenuId(submenu.id)"
          >{{ submenu.name }}
        </span>
      </div>

      <div class="categories__cat">
        <div
          class="categories__cat-wrap"
          v-for="category in categories"
          :key="category.id"
          @click="handleSearch(category.name)"
        >
          <img
            :src="
              category.image
                ? category.image
                : require('../../assets/cuisines/no_image.jpg')
            "
            alt="category.name"
          />
          <span>   {{category.name}} </span>
          
        </div>
        <div v-if="categories.length == 0" class="categories__notFound">
          <div class="notFound__body">
            <span> No Category Found</span>
            <!-- <span> Try something else...</span> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../components/Header/Header.vue";
import router from "../../router";

import {
  GetBannerService,
  MegaMenuService,
} from "../../services/items.service";
import { LocationId } from "../../services/storage.service";
// import { MegaMenuService } from "../../services/items.service";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "Categories",
  components: {
    Header,
  },

  data() {
    return {
      filteredMenu: null,
      filteredSubMenu: null,
      SubmenuId: null,
      slimBanner: "",
      isSlimBanner: false,
      categories: [],
      slug: null,
      megamenu: [],
      loading: true,
    };
  },

  computed: {
    ...mapGetters(["allMenus", "menuIds"]),
  },

  created() {
    this.loadBanner();
    this.slug = this.$route.params.slug;
    this.getMegamenu();
  },

  watch: {
    $route(to, from) {
      this.slug = to.params.slug;
      this.getfilteredMenus();
      this.getfilteredSubMenus();
      this.getfilteredCategories();
    },
    SubmenuId() {
      this.getfilteredCategories();
    },

    megamenu() {
      this.getfilteredMenus();
      this.getfilteredSubMenus();
      this.getfilteredCategories();
    },
  },

  methods: {
    getMegamenu() {
      MegaMenuService.getMenus(LocationId.getLocationId())
        .then((response) => {
          this.megamenu = response;
          // alert("helllo");
        })
        .catch((err) => console.log(err));
    },

    getfilteredMenus() {
      // console.log(test, "hello this is paramsssssssssssssssss")
      // console.log(this.slug, "helololo this slugggggggggggggg");
      const _filteredMenu = this.megamenu.filter((i) => i.name === this.slug);
      this.filteredMenu = _filteredMenu;
    },

    getfilteredSubMenus() {
      const _filteredsubMenu = this.filteredMenu.map((m) => m.submenus);
      this.filteredSubMenu = _filteredsubMenu.flat();

      this.SubmenuId = this.filteredSubMenu[0].id;
    },

    getSubmenuId(id) {
      this.SubmenuId = id;
    },

    getfilteredCategories() {
      const filterCategory = this.filteredSubMenu.filter(
        (i) => i.id == this.SubmenuId
      );

      const _categories = filterCategory.map((cat) => cat.category_info);
      this.categories = _categories.flat();

      // console.log(this.categories, "fiterrrrrrrrrrrrrrrrrrrrrrrrrrrr");
    },

    loadBanner() {
      GetBannerService.getItems(LocationId.getLocationId(), "")
        .then((response) => {
          // console.log(response, "respomse from vategoriessssssss.vue")
          let slim = response.data.filter((data) => data.type === "slim");
          this.slimBanner = slim[0].image;
          this.isSlimBanner = true;
        })
        .catch((err) => console.log(err));
    },

    onClickCategory(cat) {
      if (LocationId.getLocationId() == 1) {
        router.push(`/ktm/k/${this.slug}/${cat}`);
        // router.push("/ktm/k/" + this.slug);
      } else if (LocationId.getLocationId() == 2) {
        router.push("/pkr/k/" + this.slug);
      }
    },

    handleSearch(searchquery) {
      console.log("redirect", searchquery);
      if (LocationId.getLocationId() == 1) {
        this.$router.replace({
          name: "Search",
          params: { loc: "ktm" },
          query: { q: searchquery },
        });
      } else if (LocationId.getLocationId() == 2) {
        this.$router.replace({
          name: "Search",
          params: { loc: "pkr" },
          query: { q: searchquery },
        });
      }
    },
  },

  mounted() {
    // alert("hello mounted");
    // this.getMegamenu();
    // this.getfilteredMenus();
    // this.getfilteredSubMenus();
    // this.getfilteredCategories();
  },
};
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Montserrat&family=Roboto:wght@500&display=swap");

.active {
  color: red;
}

.catergories__banner {
  /* background-color: pink; */
  min-height: 200px;
  // height: 200px;
  margin: 25px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  // border: 3px solid yellow;
}

.catergories__banner > img {
  height: 100%;
  width: 80%;
  object-fit: cover;
  border-radius: 12px;
}

.categories__submenus {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  color: #222222;
  // border: 1px solid black;

  margin: 60px 10px 10px 10px;
}

.categories__submenus > span:nth-child(1) {
  color: #444444;
  font-family: "Montserrat", sans-serif;
  font-size: 18px;
  font-weight: bolder;
}

.span__submenu {
  margin: 0 10px;
  font-size: 18px;
  cursor: pointer;
  font-family: "Montserrat", sans-serif;
  // border-right: 1px solid #4e4e4e;
  padding: 0px 8px;
  transition: 0.3s all;
}

.span_Activesubmenu {
  margin: 0 10px;
  font-size: 18px;
  cursor: pointer;
  font-family: "Montserrat", sans-serif;
  // border-right: 1px solid #4e4e4e;
  padding: 0 8px;
  color: #ed2027;
  border-bottom: 2px solid #ed2027;
  font-weight: bolder;
  transition: 0.3s all;
}

.span__submenu:hover {
  color: #444444;
}

.categories__loading {
  padding: 3% 10%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  min-height: 30vh;
  font-size: 100px;
}

.categories__cat {
  // border: 1px solid black;
  padding: 3% 10%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  min-height: 30vh;
}

.categories__cat-wrap {
  display: flex;
  align-items: center;

  font-family: "Montserrat", sans-serif;
  //  border: 1px solid black; 
  width: auto;
  margin: 20px;
}

.categories__notFound {
  width: 100%;
  display: flex;
  justify-content: center;
}

.notFound__body {
  display: flex;
  flex-direction: column;
  font-family: "Montserrat", sans-serif;
}

.notFound__body > span:nth-child(1) {
  color: #646464;
  // font-weight: bolder;
  font-size: 18px;
}

.notFound__body > span:nth-child(2) {
  color: red;
}

.categories__cat-wrap > img {
  height: 55px;
  width: 55px;
  object-fit: cover;
  border-radius: 12px;
  cursor: pointer;
}

.categories__cat-wrap > span {
  color: red;
  font-weight: bolder;
  margin-left: 12px;
  cursor: pointer;
}

.categories__cat-wrap > span:hover {
  text-decoration: underline;
}

@media only screen and (max-width: 1180px) {
  .categories__cat {
    padding: 3% 2%;
  }

  .categories__cat-wrap {
    width: 120px !important;
    margin: 20px;
  }

  .categories__cat-wrap > span {
    margin-left: 10px;
    font-size: 14px;
  }

  .categories__cat-wrap > img {
    height: 35px;
    width: 35px;
  }
}

@media only screen and (max-width: 582px) {
  .span__submenu {
    margin: 9px 10px;
  }

  .span_Activesubmenu {
    font-size: 16px;
  }

  .span__submenu {
    font-size: 16px;
  }

  .categories__submenus > span:nth-child(1) {
    font-size: 16.8px;
  }
}
</style>
